module.exports = __webpack_public_path__ + "img/menu-dixingtu.af755bda.svg";